/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthLegacyTokenRequestDto } from '../../models/auth-legacy-token-request-dto';
import { AuthResponseDto } from '../../models/auth-response-dto';

export interface AuthControllerLoginLegacyToken$Params {
      body: AuthLegacyTokenRequestDto
}

export function authControllerLoginLegacyToken(http: HttpClient, rootUrl: string, params: AuthControllerLoginLegacyToken$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerLoginLegacyToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthResponseDto>;
    })
  );
}

authControllerLoginLegacyToken.PATH = '/api/auth/login-legacy-token';
